import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            light: '#8E6343', // Warm cocoa for softer accents
            main: '#7A4A2E', // Brand brown
            dark: '#5F3923', // Espresso brown for hover/contrast
            contrastText: '#FBF7F2', // Warm cream for readability
        },
        secondary: {
            light: '#6C9F8B', // Muted sage for adaptive states
            main: '#3E5E55', // Sage-teal brand support
            dark: '#2F4D45', // Deep sage for hierarchy
            contrastText: '#F4EFE8', // Light neutral text
        },
        warning: {
            light: '#F2D7A4', // Soft amber for warning context
            main: '#C88F3A', // Soft amber accent
            dark: '#A56F27', // Amber emphasis
            contrastText: '#2B241F', // Dark text for contrast
        },
        error: {
            light: '#F28B82', // Light red for softer errors
            main: '#D32F2F', // Red for error states
            dark: '#9A0007', // Dark red for intense errors
            contrastText: '#FFFFFF', // White for readability on red
        },
        background: {
            default: '#F8F3EB', // Warm off-white
            paper: '#FFFCF8', // Soft white surfaces
        },
        text: {
            primary: '#2A2521', // Charcoal text
            secondary: '#5F5750', // Calm secondary text
            disabled: '#9B9288', // Muted text
        },
    },
    typography: {
        fontFamily: "'Inter', 'Poppins', 'Segoe UI', sans-serif",
        h1: { fontWeight: 700, fontSize: '2.5rem', letterSpacing: '0.01em', color: '#2A2521' },
        h2: { fontWeight: 700, fontSize: '2rem', letterSpacing: '0.01em', color: '#2A2521' },
        h3: { fontWeight: 600, letterSpacing: '0.008em', color: '#2A2521' },
        h4: { fontWeight: 600, letterSpacing: '0.008em', color: '#2A2521' },
        h5: { fontWeight: 600, letterSpacing: '0.006em', color: '#2A2521' },
        h6: { fontWeight: 600, letterSpacing: '0.005em', color: '#2A2521' },
        subtitle1: { letterSpacing: '0.008em', color: '#2A2521' },
        subtitle2: { letterSpacing: '0.01em', color: '#5F5750' },
        body1: { fontSize: '1rem', color: '#5F5750' },
        body2: { fontSize: '0.875rem', color: '#5F5750' },
    },
});

export default theme;
